
const CACHE_IMAGE = '[cache][images]cache.image';


export {CACHE_IMAGE}